import { AnyAction, Dispatch } from 'redux';
import { Address } from '../../../../global/dto/shared-data-model';
import { getEmployeeStatus } from '../../../../global/ducks/benadmin-api';
import { stringSort } from '../../../../global/helpers/sort-helper';
import { ApiStatuses } from '../../../../global/models/api-model';
import { Complete, CompleteAndNotEnrolled, ErrorStatus, ErrorStatusInfo, MissingInfo, MissingInfoAndNotEnrolled, MissingInfoNotEnrolled, MissingInformation, NonStipendiary, Ok, OkNotEnrolled, Stipendiary } from '../../constants/constant-strings';
import { Officer } from '../institution-officers/institution-officers-models';
import { CoveredPeople, PersonWithGuid } from '../participants/participants-models';
import { EmploymentState, EmploymentStateActions, Employment, Employee, ScheduledHours, EmploymentItem, Position, UnpaidLeave } from './employment-model';

const InitialState: EmploymentState = {
	currentEmployment: null,
	employmentLoaded: false,
	employeeList: [],
	currentEmployee: null,
	nonStipEmploymentLoaded: false,
	nonStipendiaryEmployment: null,
	updateScheduledHoursStatus: ApiStatuses.None,
	updateStipPositionStatus: ApiStatuses.None,
	updateNonstipPositionStatus: ApiStatuses.None,
	addUnpaidLeaveSuccess: ApiStatuses.None,
	decreaseInSchduledHourStatus: ApiStatuses.None,
};

const updateEmploymentItems = (items: EmploymentItem[], newItem: EmploymentItem) => {
	const updatedItems = [...items.filter(x => x.id !== newItem.id), newItem];
	updatedItems.sort((a, b) => stringSort(b.start_date, a.start_date));

	return updatedItems;
};

function updateUnpaidLeave(currentEmployment: Employment, unpaidLeave: UnpaidLeave): Employment {
	const { unpaid_leaves } = currentEmployment;
	unpaid_leaves.push(unpaidLeave);
	return { ...currentEmployment, unpaid_leaves };
}


export const employmentReducer = (state = InitialState, action: AnyAction): EmploymentState => {

	switch (action.type) {

		case EmploymentStateActions.SET_EMPLOYMENT: {
			return {
				...state,
				currentEmployment: action.payload,
				employmentLoaded: true,
			};
		}
		case EmploymentStateActions.SET_EMPLOYMENT_FAIL:
			return { ...state, employmentLoaded: false };
		case EmploymentStateActions.SET_EMPLOYEE_LIST:
			return {
				...state,
				employeeList: action.payload,
			};
		case EmploymentStateActions.SET_CURRENT_EMPLOYEE:
			return {
				...state,
				currentEmployee: action.payload,
			};
		case EmploymentStateActions.UPDATE_SCHEDULED_HOURS:
			return {
				...state,
				currentEmployment: {
					...state.currentEmployment,
					scheduled_hours: updateEmploymentItems(state.currentEmployment?.scheduled_hours, action.payload) as ScheduledHours[],
				},
			};
		case EmploymentStateActions.UPDATE_SCHEDULED_HOURS_STATUS:
			return {
				...state,
				updateScheduledHoursStatus: action.payload,
			};
		case EmploymentStateActions.DECREASE_IN_SCHEDULED_HOURS:
			return {
				...state,
				decreaseInSchduledHourStatus: action.payload,
			};
		case EmploymentStateActions.SET_NON_STIPENDIARY_EMPLOYMENT:
			return {
				...state,
				nonStipendiaryEmployment: action.payload,
				nonStipEmploymentLoaded: true,
			};
		case EmploymentStateActions.UPDATE_STIP_POSITION:
			return {
				...state,
				currentEmployment: {
					...state.currentEmployment,
					position_titles: updateEmploymentItems(state.currentEmployment?.position_titles, action.payload) as Position[],
				},
			};
		case EmploymentStateActions.UPDATE_STIP_POSITION_STATUS:
			return {
				...state,
				updateStipPositionStatus: action.payload,
			};
		case EmploymentStateActions.UPDATE_NON_STIP_POSITION:
			return {
				...state,
				nonStipendiaryEmployment: {
					...state.nonStipendiaryEmployment,
					position_titles: updateEmploymentItems(state.nonStipendiaryEmployment?.position_titles, action.payload) as Position[],
				},
			};
		case EmploymentStateActions.UPDATE_NON_STIP_POSITION_STATUS:
			return {
				...state,
				updateNonstipPositionStatus: action.payload,
			};
		case EmploymentStateActions.SET_UNPAID_LEAVES:
			return {
				...state,
				currentEmployment: updateUnpaidLeave(state.currentEmployment, action.payload),
			};

		case EmploymentStateActions.SET_ADD_UNPAID_LEAVES_STATUS:
			return {
				...state,
				addUnpaidLeaveSuccess: action.payload,
			};
		case EmploymentStateActions.REMOVE_STIP_EMPLOYMENT:
			return {
				...state,
				currentEmployment: null,
				employmentLoaded: false,
			};
		case EmploymentStateActions.REMOVE_NON_STIP_EMPLOYMENT:
			return {
				...state,
				nonStipendiaryEmployment: null,
				nonStipEmploymentLoaded: false,
			};
		case EmploymentStateActions.UNSET_EMPLOYMENT_STATE:
			return {
				...state,
				currentEmployment: null,
				employmentLoaded: false,
				currentEmployee: null,
				nonStipEmploymentLoaded: false,
				nonStipendiaryEmployment: null,
				updateScheduledHoursStatus: ApiStatuses.None,
				updateStipPositionStatus: ApiStatuses.None,
				updateNonstipPositionStatus: ApiStatuses.None,
				addUnpaidLeaveSuccess: ApiStatuses.None,
				decreaseInSchduledHourStatus: ApiStatuses.None,
			};
		default: return state;
	}
};

export const setEmployment = (employment: Employment) => {
	return {
		type: EmploymentStateActions.SET_EMPLOYMENT,
		payload: employment,
	};
};

export const setEmploymentFail = () => {
	return {
		type: EmploymentStateActions.SET_EMPLOYMENT_FAIL,
	};
};


export const dispatchSetEmployment = (dispatch: Dispatch<any>) => (response) => {
	dispatch(setEmployment(response.data));
};

export const dispatchSetEmploymentFailed = (dispatch: Dispatch<any>) => {
	dispatch(setEmploymentFail());
};


export const setEmployeeList = (employees: Employee[]) => {
	return {
		type: EmploymentStateActions.SET_EMPLOYEE_LIST,
		payload: employees,
	};
};




export const getEmploymentType = (stip: boolean, noStip: boolean) => {
	if (stip) {
		return Stipendiary;
	}
	if (noStip) {
		return NonStipendiary;
	}
	return '';
};

export const getStatusDisplay = (status: string) => {
	if (status === Ok) {
		return Complete;
	}
	if (status === MissingInformation) {
		return MissingInfo;
	}
	if (status === OkNotEnrolled) {
		return CompleteAndNotEnrolled;
	}
	if (status === MissingInfoNotEnrolled) {
		return MissingInfoAndNotEnrolled;
	}
	if (status === ErrorStatus) {
		return ErrorStatusInfo;
	}
	return '';
};

const getFullAddress = (address: Address) => {
	return `${address?.address1} ${address?.address2} ${address?.address3} ${address?.city} ${address?.state} ${address?.postal_code} ${address?.country}`;
};

const processEmployeeList = (employees: Employee[]) => {
	const newList = employees?.map(
		a => {
			return {
				...a,
				employmentType: getEmploymentType(a.stipendiary_status, a.non_stipendiary_position),
				statusDisplay: getStatusDisplay(a.status_indicator),
				fullAddress: getFullAddress(a.address),
			};
		},
	);
	return newList;
};

export const dispatchSetEmployeeList = (dispatch: Dispatch<any>) => (response) => {

	dispatch(setEmployeeList(processEmployeeList(response.data.map(x => x.employee))));
};

export const setCurrentEmployee = (employee: Employee | Officer | CoveredPeople | PersonWithGuid ) => {
	return {
		type: EmploymentStateActions.SET_CURRENT_EMPLOYEE,
		payload: employee,
	};
};

export const dispatchSetCurrentEmployee = (dispatch: Dispatch<any>, employee: any) => {
	if (employee?.guid && employee?.employment_id) {
		dispatch(getEmployeeStatus(
			employee?.guid,
			employee?.employment_id,
			(response) => {
				const shallowCopy = { ...employee };
				shallowCopy.locks = response?.locks;
				dispatch(setCurrentEmployee(shallowCopy));
			}),
		);
	}
	dispatch(setCurrentEmployee(employee));

};



export const updateScheduledHours = (scheduledHours: ScheduledHours) => {
	return {
		type: EmploymentStateActions.UPDATE_SCHEDULED_HOURS,
		payload: scheduledHours,
	};
};

export const setUpdateScheduledHoursStatus = (status: ApiStatuses) => {
	return {
		type: EmploymentStateActions.UPDATE_SCHEDULED_HOURS_STATUS,
		payload: status,
	};
};

export const setNonStipendiaryEmployment = (employment: Employment) => {
	return {
		type: EmploymentStateActions.SET_NON_STIPENDIARY_EMPLOYMENT,
		payload: employment,
	};
};

export const dispatchSetNonStipendiaryEmployment = (dispatch: Dispatch<any>, employerClientNumber: string) => (response) => {
	dispatch(setNonStipendiaryEmployment(response?.data?.filter(a => a.employer_client_number === employerClientNumber)[0]));
};

export const updateStipPosition = (stipPosition: Position) => {
	return {
		type: EmploymentStateActions.UPDATE_STIP_POSITION,
		payload: stipPosition,
	};
};

export const setUpdateStipPositionStatus = (status: ApiStatuses) => {
	return {
		type: EmploymentStateActions.UPDATE_STIP_POSITION_STATUS,
		payload: status,
	};
};

export const updateNonStipPosition = (nonStipPosition: Position) => {
	return {
		type: EmploymentStateActions.UPDATE_NON_STIP_POSITION,
		payload: nonStipPosition,
	};
};

export const setUpdateNonStipPositionStatus = (status: ApiStatuses) => {
	return {
		type: EmploymentStateActions.UPDATE_NON_STIP_POSITION_STATUS,
		payload: status,
	};
};

export const setUnpaidLeave = (unpaidLeave: UnpaidLeave) => {
	return {
		type: EmploymentStateActions.SET_UNPAID_LEAVES,
		payload: unpaidLeave,
	};
};

export const setUnpaidLeaveStatus = (status: ApiStatuses) => {
	return {
		type: EmploymentStateActions.SET_ADD_UNPAID_LEAVES_STATUS,
		payload: status,
	};
};

export const unSetEmploymentState = () => {
	return {
		type: EmploymentStateActions.UNSET_EMPLOYMENT_STATE,
	};
};

export const removeStipEmployment = () => {
	return {
		type: EmploymentStateActions.REMOVE_STIP_EMPLOYMENT,
	};
};

export const removeNonStipEmployment = () => {
	return {
		type: EmploymentStateActions.REMOVE_NON_STIP_EMPLOYMENT,
	};
};

export const setDecreaseInScheduledHoursStatus = (status: ApiStatuses) => {
	return {
		type: EmploymentStateActions.DECREASE_IN_SCHEDULED_HOURS,
		payload: status,
	};
};